const variantName = 'menuV5'

export default {
  [variantName]: {
    // ?============================
    // ?======  Containers =========
    // ?============================

    container: {
      padding: ['3rem 0.5rem', '1rem'],
      justifyContent: 'center',
      width: '100%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    },
    innerMenuContainer: {
      width: ['100%', '', '', '50%'],
      marginLeft: ['', '', '', '50%'],
      position: 'relative'
      // paddingTop: ['125px', '', '', '100px'],
    },

    // ?============================
    // ?========  Buttons  =========
    // ?============================

    backToMenuBtn: {
      backgroundColor: 'primary',
      border: 'none',
      margin: '0.5rem',
      cursor: 'pointer',
      justifyContent: 'center',
      paddingBottom: 'calc(0.5rem - 1px)',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingTop: 'calc(0.5rem - 1px)',
      textAlign: 'center',
      whiteSpace: 'nowrap'
    },

    // ?============================
    // ?========  Images  ==========
    // ?============================

    imageFill: {
      paddingBottom: '100%' // * reuseable to make images square
    },

    // ?================================
    // ?===========  TABS  =============
    // ?================================

    tabsRow: {
      display: 'flex',
      flexWrap: 'wrap',
      overflow: 'scroll',
      padding: '20px 0',
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      justifyContent: ['', '', '', 'center'],
      '.sectionTab': {
        margin: '10px'
      }
    },

    sectionTab: {
      margin: '0.25rem',
      minWidth: 'max-content',
      maxWidth: 'max-content',
      width: '100%',
      border: '1px solid black',
      padding: '0.75rem 1.5rem',
      cursor: 'pointer',
      color: 'text',
      '&:hover': {
        backgroundColor: 'secondary',
        color: '#fff',
        transition: 'all 0.5s'
      }
    },

    sectionTabActive: {
      variant: `${variantName}.sectionTab`,
      backgroundColor: 'primary',
      color: 'light'
    },

    // ?================================
    // ?=========  Slider  =============
    // ?================================

    menuSliderContainer: {
      display: ['none', '', '', 'flex'],
      flexDirection: 'column',
      width: ['100%', '', '', '50%'],
      height: '100vh',
      position: 'fixed',
      left: '0%',
      top: '0%',

      '.slick-slider, .slick-list, .slick-track, .slick-slide, .slick-slide > div': {
        width: '100%',
        height: 'inherit'
      },
      '.slick-arrow': {
        width: '30px',
        zIndex: '100',
        height: '30px',
        backgroundColor: 'white',
        path: {
          fill: 'primary'
        }
      },
      '.slick-prev': {
        left: '0rem'
      },
      '.slick-next': {
        right: '0rem'
      },
      '.slick-dots': {
        position: 'fixed',
        top: '50%',
        transform: 'translateY(-50%)',
        height: 'fit-content',
        left: '1rem',
        width: 'fit-content',
        display: 'none !important',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        li: {
          display: 'flex',
          width: '30px',
          height: '30px',
          button: {
            width: '30px',
            height: '30px',
            '::before': {
              fontSize: '16px',
              color: 'primary',
              width: '30px',
              height: '30px'
            }
          }
        }
      }
    },

    sliderCloseButton: {
      position: 'absolute',
      bottom: 'calc(1rem)',
      right: '1rem',
      zIndex: '600',
      svg: {
        backgroundColor: 'secondary',
        color: 'white',
        width: '30px',
        height: '30px',
        fill: 'light'
      },
      ':hover': {
        backgroundColor: 'black'
      }
    },
    sliderImage: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      zIndex: '-1',
      backgroundColor: 'background'
    },

    lightboxImage: {
      position: 'fixed',
      top: '0rem',
      left: '0rem',
      width: '50%',
      height: '100%',
      objectFit: 'cover',
      zIndex: '500',
      img: {
        height: '100%',
        width: '100%',
        objectFit: 'cover'
      }
    },

    menuItemCamera: {
      svg: {
        width: '20px',
        height: '20px'
      }
    },

    lightboxText: {
      position: 'fixed',
      bottom: '0rem',
      backgroundColor: 'secondary',
      color: ['red', 'white'],
      left: '0rem',
      zIndex: '1004',
      width: '50%',
      display: 'flex',
      justifyContent: 'center',
      padding: '1rem',
      fontSize: '1.25rem',
      fontFamily: 'heading'
    },

    // ?================================
    // ?=========  ALL IN  =============
    // ?================================

    allInContainer: {},
    menuContainer: { paddingBottom: '1rem' },

    // ?================================
    // ?=========  CELLS  ==============
    // ?================================

    cellContainer: {
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'center',
      flexWrap: 'wrap'
    },

    sectionCell: {
      cursor: 'pointer',
      width: [
        '100%',
        'calc(50% - (0.5rem * 2))',
        'calc(33.333% - (0.5rem * 2))',
        'calc(33% - (0.5rem * 2))',
        'calc(25% - (0.5rem * 2))'
      ],
      backgroundColor: 'secondary',
      borderRadius: '10px',
      margin: ['1rem 0', '0.5rem']
    },

    menuCell: {
      flexWrap: 'wrap',
      border: 'solid 1px black',
      borderRadius: '10px',
      height: '100%',
      backgroundColor: 'background'
    },
    cellImageContainer: {
      position: 'relative',
      width: '100%',
      height: 'unset'
    },
    cellImage: {
      objectFit: 'cover',
      height: '100%',
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '10px 10px 0 0'
    },
    cellImageLogo: {
      objectFit: 'contain',
      height: '100%',
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '10px 10px 0 0'
    },
    cellName: {
      margin: '1rem',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      textTransform: 'uppercase'
    },

    // ?================================
    // ?========  Menu Sections ========
    // ?================================

    menuSectionTitle: {
      fontSize: '2rem',
      textAlign: 'center',
      margin: '2rem'
    },
    menuSectionDescription: {
      fontSize: 4,
      marginBottom: '1.25rem',
      textAlign: 'center'
    },
    menuItemsContainer: {
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      marginBottom: 0
    },

    // ?================================
    // ?========  Menu Items ===========
    // ?================================

    menuItemContainer: {
      display: 'flex',
      overflow: 'hidden',
      padding: ['0 0.5rem', '', '0 1rem'],
      marginBottom: '1rem',
      margin: ['', '0.5rem'],
      width: ['100%', '', 'calc(50% - (0.5rem * 2))'],
      transition: 'all ease-in-out 0.5s'
    },
    menuItemContainerImgActive: {
      variant: `${variantName}.menuItemContainer`
    },
    menuItemInnerContainer: {
      // marginBottom: '1rem',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexGrow: 1,
      alignItems: 'stretch'
    },

    // ?================================
    // ?======  Menu Item Image  =======
    // ?================================

    menuItemImageContainer: {
      borderRadius: '10px 10px 0 0',
      position: 'relative',
      cursor: 'pointer',
      maxWidth: ['30%', '150px'],
      maxHeight: ['150px'],
      display: ['', '', '', 'none']
    },
    itemImageFill: {},
    menuItemImg: {
      objectFit: 'cover',
      height: '100%',
      width: '100%',
      padding: '0 0.75rem 0 0',
      cursor: 'pointer'
    },
    menuItemImgDefault: {
      position: 'unset',
      objectFit: 'contain',
      display: 'none'
    },

    // ?================================
    // ?=====  Menu Item Content  ======
    // ?================================

    menuItemContentContainer: {
      height: '100%',
      flexDirection: 'column',
      width: '100%',
      // margin: '1rem 0rem',
      position: 'relative'
    },
    menuItemName: {
      fontSize: ['1rem', '1.1rem', '', '1.2rem'],
      fontWeight: 'bolder',
      margin: '0px',
      marginBottom: '1rem',
      paddingRight: '8px'
    },
    menuItemDescription: {
      fontSize: '0.9rem',
      whiteSpace: 'break-spaces',
      width: '90%'
    },

    // ?================================
    // ?======  Menu Items Price =======
    // ?================================

    menuPriceContainer: {
      flexGrow: '1',
      fontSize: ['1rem', '1.1rem'],
      justifyContent: 'flex-end'
    },

    menuItemPrice: {
      margin: '0px',
      textAlign: 'right'
    },

    variantsContainer: {},

    labelTitle: {
      display: 'flex'
    },
    variantContainer: {
      marginBottom: '8px',
      display: 'flex'
    },

    variantContainerFloatTopRight: {
      position: 'absolute',
      right: '0rem',
      top: '0rem'
    },

    menuItemPriceLabel: {
      margin: '0px',
      marginRight: '8px'
    },
    menuItemPriceVariants: {},

    // ?================================
    // ?======= Section Dropdown =======
    // ?================================

    dropdownContainer: {
      justifyContent: 'center',
      position: 'relative'
    },

    menuDropdownBtn: {
      background: 'primary',
      border: '2px solid',
      textTransform: 'uppercase',
      fontWeight: '600',
      fontSize: '1.25rem',
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: '4px',
      padding: '0.75rem 1.75rem'
    },

    menuSectionsDropDownContainer: {
      backgroundColor: 'background',
      boxShadow: '2px 2px 8px lightgrey',
      borderRadius: '10px',
      position: 'absolute',
      top: '100%',
      zIndex: '100',
      margin: '0 2.5%',
      display: 'flex',
      justifyContent: 'center',
      div: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '1rem',
        borderRadius: '4px',
        margin: 'auto',
        justifyContent: 'center'
      }
    },

    dropdownSection: {
      width: ['calc(50% - (0.5rem * 2))', 'calc(33.33% - (0.5rem * 2))'],
      margin: '0.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      cursor: 'pointer',
      fontWeight: 'bold',
      fontSize: '1.25rem',
      span: {
        '&:hover': {
          textDcoration: 'underline'
        }
      }
    },

    // ?================================
    // ?========== Empty Menu  =========
    // ?================================

    noItemsContainer: {
      width: '100%',
      minHeight: '30vh',
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }
}
